import React from "react";
import Subscription from "@/pages/Subscription";

export default function OwnerSubscriptions() {
  return <Subscription />;
}
